import { faLock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ComponentProps } from 'preact';

import { cn } from '@/lib/utils';

const LockBadge = ({ className, ...rest }: ComponentProps<'span'>) => {
  return (
    <span
      className={cn(
        'inline-flex size-4 items-center justify-center rounded-full bg-[#C89400] text-center text-[10px]/none text-white',
        className,
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    >
      <FontAwesomeIcon icon={faLock} />
      <span className="sr-only">Premium user only</span>
    </span>
  );
};

export default LockBadge;
